import React from 'react';
import { motion } from 'framer-motion';
import './SignUpLeftVisual.css';

function SignUpLeftVisual() {
  return (
    <div className="signup-left-visual">
      <motion.h1
        className="signup-brand-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      >
        Where clarity begins
      </motion.h1>
      <motion.p
        className="signup-tagline"
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      >
        Better work follows
      </motion.p>
      <div className="signup-visual-container">
        {Array.from({ length: 6 }).map((_, i) => (
          <motion.div
            key={i}
            className="signup-particle"
            style={{
              left: `${20 + (i % 3) * 30}%`,
              top: `${30 + Math.floor(i / 3) * 30}%`,
            }}
            initial={{ opacity: 0, scale: 0 }}
            animate={{
              opacity: [0.3, 1, 0.3],
              scale: [0.8, 1.2, 0.8],
            }}
            transition={{
              duration: 2,
              delay: 0.4 + i * 0.1,
              repeat: Infinity,
              ease: 'easeInOut',
            }}
          />
        ))}
        <motion.div
          className="signup-pulse-ring"
          initial={{ scale: 0.8, opacity: 0.8 }}
          animate={{
            scale: [0.8, 1.5, 0.8],
            opacity: [0.8, 0, 0.8],
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      </div>
    </div>
  );
}

export default SignUpLeftVisual;
